<template>
  <div class="f-l m-r-10 mh-400 ovf-y-auto">
    <div class="m-r-10" v-if="isShow">
      <h3 class="m-t-0" v-if="currentInput.default">{{currentInput.default.title}}控件传值</h3>
      <el-form>
        <el-form-item label="不可见传值" v-if="isShowValue">
          <el-select clearable class="m-b-10 w-100p" placeholder="请选择方式" v-model="currentInput.way" @change="changeWay()">
            <el-option
              v-for="item in ways"
              :key="item.value"
              :label="item.way"
              :value="item.value">
            </el-option>
          </el-select>
          <br/>
          <el-select clearable class="w-100p" placeholder="请选择" v-model="currentInput.field_default" v-if="currentInput.way == 20">
            <el-option
              v-for="item in userInfos"
              :key="item.value"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
          <el-input v-model="currentInput.field_default" class="h-40" placeholder="请输入" v-if="currentInput.way == 10"></el-input>
        </el-form-item>

        <!--外键控件  -->
        <el-form-item v-if="isShowForignKey" label="筛选条件">
          <div v-for="(item, index) in currentInput.key_filter" class="m-b-10">
             <el-input class="w-300" v-model="currentInput.key_filter[index]"></el-input> 
             <el-button class="m-l-20" type="danger" @click="deleteKeyFilterItem(index)">删除</el-button>
          </div>
          <span style="color: red;">*</span>支持等于==, 不等于<>, 小于<逻辑判断
          <el-button type="primary" @click="addKeyFilterItem()">增加</el-button>
        </el-form-item>
        <el-form-item v-if="isShowForignKey" label="连带获取联表字段并显示">
          <el-table
            :data="currentInput.key_depent">
            <el-table-column label="选择字段">
              <template scope="scope">
                <el-select v-model="scope.row.name" placeholder="请选择字段">
                  <el-option
                    v-for="item in major_list"
                    :label="item.field+'('+item.title+')'"
                    :value="item.field"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="显示名称">
              <template scope="scope">
                <el-input v-model="scope.row.title" placeholder="请输入"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="80">
              <template scope="scope">
                <el-button size="small" type="danger" @click="deleteKeyDepent(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-button class="w-100p" type="primary" @click="addKeyDepent">添加一行</el-button>
        </el-form-item>
        <el-form-item v-if="isShowForignKey" label="连带获取联表字段并填到本表单控件">
          <el-table
            :data="currentInput.key_fillin">
            <el-table-column label="选择字段">
              <template scope="scope">
                <el-select v-model="scope.row.fill_field">
                  <el-option
                    v-for="item in major_list"
                    :label="item.field+'('+item.title+')'"
                    :value="item.field">
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="选择本表单控件">
              <template scope="scope">
                 <el-select v-model="scope.row.be_fill_field">
                  <el-option
                    v-for="item in inputList"
                    :label="item.default.name"
                    :value="item.default.name">
                  </el-option>
                </el-select> 
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template scope="scope">
                <el-button size="small" type="danger" @click="deleteKeyFillin(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-button class="w-100p" type="primary" @click="addKeyFillin">添加一行</el-button>
        </el-form-item>
        <el-form-item v-if="isShowForignKey" label="配置本外键数据筛选配置（实现外键级联）">
          <el-select v-model="currentInput.key_cascade.major_field" clearable class="m-b-10 w-100p" placeholder="请选择本表中同级字段控件">
            <el-option
              v-for="item in inputList"
              :label="item.default.name"
              :value="item.default.name"
              v-if="contrastForignKeyType(item.default.type, item.default.name)">
            </el-option>
          </el-select>
          <el-select v-model="currentInput.key_cascade.extra_field" clearable class="m-b-10 w-100p" placeholder="请选择本表中外键关联字段">
            <el-option
              v-for="item in major_list"
              :label="item.title"
              :value="item.field">
            </el-option>
          </el-select>
          <!-- <el-select v-model="currentInput.key_cascade.extra_field" :multiple-limit="limitNumber" multiple clearable class="w-100p" placeholder="请选择关联字段">
            <el-option
              v-for="item in extra_list"
              :label="item.title"
              :value="item.field">
            </el-option>
          </el-select> -->
        </el-form-item>
        <!--外键控件  -->

        <!--下拉/单选/复选  -->
        <el-form-item v-if="isShowOption" label="关联筛选关系">
          <el-select clearable class="w-100p" v-model="currentInput.option_relation.major_field" @change="changeOption()" placeholder="请选择本表关联字段">
            <el-option
              v-for="item in inputList"
              :label="item.default.name+item.default.title"
              :value="item.default.name"
              v-if="contrastOptionType(item.default.type, item.default.name)">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="isShowOption">
          <el-table
            :data="currentInput.option_relation.relation">
            <el-table-column label="选项值" width="80">
              <template scope="scope">
                {{scope.row.option_name.name}}
              </template>
            </el-table-column>
            <el-table-column label="本控件可用值">
              <template scope="scope">
                 <el-select
                  clearable
                  v-model="scope.row.input_id"
                  multiple
                  placeholder="请选择值">
                  <el-option
                    v-for="item in curInputOption"
                    :label="item.name"
                    :value="item.name">
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="80">
              <template scope="scope">
                <el-button size="small" type="danger" @click="deleteRelation(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <!--下拉/单选/复选  -->

        <!--人员/部门  -->
        <el-form-item v-if="isShowPersonOrGroup" label="关联筛选关系">
          <!--人员  -->
          <el-select clearable v-if="currentInput.default.type === TYPE_PERSON" class="m-b-10 w-100p" v-model="currentInput.people_filter.major_field" @change="changePerson" placeholder="请选择本表关联字段">
            <el-option
              v-for="item in inputList"
              :label="item.default.name+item.default.title"
              :value="item.default.name">
            </el-option>
          </el-select>
          <el-select clearable v-if="currentInput.default.type === TYPE_PERSON" class="w-100p" v-model="currentInput.people_filter.filter_field" placeholder="请选择人员表单被筛选字段">
            <el-option
              v-for="item in userInfos"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
          <!--部门  -->
          <el-select clearable v-if="currentInput.default.type === TYPE_STRUCT" class="m-b-10 w-100p" v-model="currentInput.struct_filter.major_field" @change="changePerson" placeholder="请选择本表关联字段">
            <el-option
              v-for="item in inputList"
              :label="item.default.name"
              :value="item.default.name">
            </el-option>
          </el-select>
          <!--v-if="filterPersonOrSturct(item.default.type,item.default.name)"  -->
          <el-select v-if="currentInput.default.type === TYPE_STRUCT" clearable class="w-100p" v-model="currentInput.struct_filter.filter_field" placeholder="请选择部门表单被筛选字段">
            <el-option
              v-for="item in structList"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <!--人员/部门  -->


        <!--日期/日期时间/时间/单行文本（整型 浮点 公式）  -->
        <el-form-item v-if="isShowByDateOrOther" label="大小关系限制">
          <el-table
            :data="currentInput.logic_condition">
            <el-table-column label="比较逻辑">
              <template scope="scope">
                <el-select v-model="scope.row.logic" placeholder="计算公式" class="w-150 m-r-10">
                  <el-option v-for="option in logicTypes" :key="option" :label="option.name" :value="option.id" v-if="configTypes(option)"></el-option>
                </el-select>  
              </template>
            </el-table-column>
            <el-table-column label="比较字段">
              <template scope="scope">
                <el-select clearable v-model="scope.row.field_name_2" placeholder="字段二" class="fl w-150 m-r-10"  @change="logicFiledChange()">
                  <el-option v-for="option in scope.row.logicOptions2" :label="option.title" :value="option.name" ></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="80">
              <template scope="scope">
                <el-button size="small" type="danger" @click="deleteLogicCondition(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-button class="w-100p" type="primary" @click="addLogicCondition">添加一行</el-button>
        </el-form-item>
        <!--日期/日期时间/时间/单行文本（整型 浮点 公式）  -->
      </el-form>
    </div>
  </div>
</template>
<script>
import http from '../../../../assets/js/http'
import modelConfig from '../../../../config/modelConfig'
import flowConfig from '../../../../config/flowConfig'
export default {
  props: ['currentInput', 'inputList', 'userInfos', 'structList'],
  data() {
    return {
      logicTypes: [ // 逻辑数组
        { id: '=', name: '等于' },
        { id: '!=', name: '不等于' },
        { id: '>', name: '大于' },
        { id: '<', name: '小于' },
        { id: '<=', name: '小于等于' },
        { id: '>=', name: '大于等于' },
        { id: '70', name: '包含' }
      ],
      ways: [
        {
          way: '常量',
          value: 10
        },
        {
          way: '登录用户的信息',
          value: 20
        }
      ],
      logicConditionModel: {
        field_name_1: '',
        logic: { id: '=', name: '等于' },
        field_name_2: '',
        logicOptions2: []
      },
      keyDepentModel: {
        name: '',
        title: ''
      },
      keyFillinModel: {
        be_fill_field: '',
        fill_field: ''
      },
      curInputOption: [],
      major_field: '',
      limitNumber: 1,
      extra_list: [],
      major_list: []
    }
  },
  methods: {
    configTypes(option) {
      if (option.id === '70') {
        return false
      }
      return true
    },
    contrastInputType() {
      if (this.currentInput && this.currentInput.default && this.currentInput.default.type) {
        let type = this.currentInput.default.type
        if (type === this.TYPE_INPUTTEXT || type === this.TYPE_DATE || type === this.TYPE_BOTH_DATE_TIME || type === this.TYPE_TIME) {
          if (type === this.TYPE_INPUTTEXT) {
            let write_type = this.currentInput.input.write_type
            if (write_type === this.TYPE_NUMBER || write_type === this.TYPE_FLOATNUMBER || write_type === this.TYPE_FORMULA) {
              return true
            }
            return false
          }
          return true
        }
      }
      return false
    },
    contrastPersonOrGroup() {
      if (this.currentInput && this.currentInput.default && this.currentInput.default.type) {
        let type = this.currentInput.default.type
        // 假数据
        if (type === this.TYPE_PERSON) {
          return true
        }
        if (type === this.TYPE_STRUCT) {
          return true
        }
      }
      return false
    },
    contrastOptionType(option_type, name) {
      if (this.currentInput && this.currentInput.default && this.currentInput.default.type) {
        let type
        let cur_name = this.currentInput.default.name
        if (option_type) {
          type = option_type
          if (cur_name === name) {
            return false
          }
        } else {
          type = this.currentInput.default.type
        }
        if (type === this.TYPE_RADIO || type === this.TYPE_CHECKBOX || type === this.TYPE_SELECT) {
          return true
        }
      }
      return false
    },
    contrastForignKeyType(option_type, option_name) {
      if (this.currentInput && this.currentInput.default && this.currentInput.default.type) {
        let type
        if (option_type) {
          type = option_type
        } else {
          type = this.currentInput.default.type
        }
        if (option_name) {
          if (option_name === this.currentInput.default.name) {
            return false
          }
        }
        if (type === this.TYPE_FOREIGNKEY) {
          return true
        }
      }
      return false
    },
    // filterPersonOrSturct(type, name) {
    //   if (type === this.currentInput.default.type &&
    //     name !== this.currentInput.default.name) {
    //     return true
    //   }
    //   return false
    // },
    logicFiledChange() {
      if (this.inputList && this.inputList.length > 0) {
        let type = this.currentInput.default.type
        let name = this.currentInput.default.name
        let commArr = []
        _(this.currentInput.logic_condition).forEach((res) => {
          res.logicOptions2 = []
        })
        _(this.inputList).forEach((res, index) => {
          res.isSelected = undefined
        })
        // 记录类型和当前控件类型一致，并且name没有重复的数据
        _(this.inputList).forEach((res, index) => {
          // CMS 常量更改
          if (type === this.TYPE_INPUTTEXT && res.default.type === this.TYPE_INPUTTEXT) {
            let write_type = this.currentInput.input.write_type
            if (res.input.write_type !== write_type) {
              // console.log('同种控件不同input类型' + write_type + '--' + res.input.write_type)
              return
            }
          }
          if (res.default.type === type && res.default.name !== name) {
            // 先判断该值是否已经被选中
            _(this.currentInput.logic_condition).forEach((sRes, sindex) => {
              if (res.isSelected) {
                return
              }
              if (res.default.name === sRes.field_name_2) {
                res.isSelected = true
                res.index = sindex
                return
              }
              res.isSelected = false
            })
          }
        })
        _(this.inputList).forEach((res, index) => {
          let obj = {
            name: res.default.name,
            title: res.default.title
          }
          if (res.isSelected === false) {
            // 没有被选中，而且满足上面过滤条件
            // console.log("公共加", obj)
            commArr.push(obj)
          } else if (res.isSelected) {
            this.currentInput.logic_condition[res.index].logicOptions2.push(obj)
            // console.log('引入选中部分', this.currentInput.logic_condition)
          }
        })
        // console.log("公共部分", commArr)
        _(this.currentInput.logic_condition).forEach((res) => {
          // console.log('合并前数据', res)
          res.logicOptions2 = res.logicOptions2.concat(commArr)
          // console.log('合并后数据', res.logicOptions2)
        })
      }
    },
    addLogicCondition() {
      // 大小关系增加一行
      let obj = _.cloneDeep(this.logicConditionModel)
      obj.field_name_1 = this.currentInput.default.name
      this.currentInput.logic_condition.push(obj)
      this.logicFiledChange()
    },
    addKeyFilterItem() {
      this.currentInput.key_filter.push('')
    },
    deleteKeyFilterItem(index) {
      this.currentInput.key_filter.splice(index, 1)
    },
    deleteLogicCondition(index) {
      // 大小关系删除一行
      this.currentInput.logic_condition.splice(index, 1)
      this.logicFiledChange()
    },
    deleteRelation(index) {
      this.currentInput.option_relation.relation.splice(index, 1)
    },
    addKeyDepent() {
      let obj = _.cloneDeep(this.keyDepentModel)
      this.currentInput.key_depent.push(obj)
    },
    deleteKeyDepent(index) {
      this.currentInput.key_depent.splice(index, 1)
    },
    addKeyFillin() {
      let obj = _.cloneDeep(this.keyFillinModel)
      this.currentInput.key_fillin.push(obj)
    },
    deleteKeyFillin(index) {
      this.currentInput.key_fillin.splice(index, 1)
    },
    changeWay() {
      this.currentInput.field_default = ''
    },
    changeOption() {
      if (this.currentInput.option_relation.major_field === this.major_field) {
        return
      }
      this.major_field = this.currentInput.option_relation.major_field
      // console.log('this.currentInput.option_relation.major_field', this.currentInput.option_relation.major_field)
      // 获取选项值
      let temp = []
      _(this.inputList).forEach((res) => {
        if (res.default.name === this.currentInput.option_relation.major_field) {
          if (res.default.type === this.TYPE_RADIO) {
            temp = res.radio_option
          } else if (res.default.type === this.TYPE_CHECKBOX) {
            temp = res.checkbox_option
          } else if (res.default.type === this.TYPE_SELECT) {
            temp = res.select_option
          }
        }
      })
      this.currentInput.option_relation.relation = []
      if (temp && temp.length > 0) {
        _(temp).forEach((res) => {
          let obj = {
            option_name: res,
            input_id: []
          }
          this.currentInput.option_relation.relation.push(obj)
        })
      }
      // this.relation = this.currentInput.option_relation.relation
    },
    changePerson() {
      // console.log(this.currentInput.test)
    }
    // changeCascade() { // 根据当前id获取额外字段列表
    //   let id = this.currentInput.key_cascade.cascade_field
    //   if (!id) {
    //     return
    //   }
    //   this.currentInput.key_cascade.extra_field = []
    //   this.apiGet(`cms/deals/foreign_fields/${id}`).then((res) => {
    //     if (res.code === 200) {
    //       this.extra_list = res.data
    //       return
    //     }
    //     this.extra_list = []
    //   })
    // }
  },
  watch: {
    'currentInput'() {
      // console.log('this.currentInput', this.currentInput)
      if (this.currentInput) {
        // 判断一
        if (this.isShow && this.isShowByDateOrOther) {
          this.logicFiledChange()
        }
        // 判断二
        if (this.isShow && this.isShowOption) {
          this.major_field = this.currentInput.option_relation.major_field
          // this.relation = this.currentInput.option_relation.relation
          _(this.inputList).forEach((res) => {
            if (res.default.name === this.currentInput.default.name) {
              if (res.default.type === this.TYPE_RADIO) {
                this.curInputOption = res.radio_option
              } else if (res.default.type === this.TYPE_CHECKBOX) {
                this.curInputOption = res.checkbox_option
              } else if (res.default.type === this.TYPE_SELECT) {
                this.curInputOption = res.select_option
              }
            }
          })
          // console.log('this.curInputOption', this.curInputOption)
        }
        // 判断三 -外键
        if (this.isShow && this.isShowForignKey) {
          // 获取父级字段控件列表
          let id = this.currentInput.default.field_id
          if (!id) {
            return
          }
          this.apiGet(`cms/deals/foreign_fields/${id}`).then((res) => {
            if (res.code === 200) {
              this.major_list = res.data
            } else {
              this.major_list = []
            }
          })
        }
      }
    }
  },
  computed: {
    isShow() {
      if (this.currentInput.auth === this.INPUT_HIDDEN) {
        return false
      }
      return true
    },
    isShowOption(option_type) {
      // 下拉/单选/复选
      return this.contrastOptionType()
    },
    isShowByDateOrOther() {
      return this.contrastInputType()
    },
    isShowValue() {
      return this.currentInput.auth === this.INPUT_EXIST
    },
    isShowPersonOrGroup() {
      return this.contrastPersonOrGroup()
    },
    isShowForignKey() {
      return this.contrastForignKeyType()
    }
  },
  mixins: [http, modelConfig, flowConfig]
}
</script>



// WEBPACK FOOTER //
// rightInputConfig.vue?adcd95bc